import CloseIcon from "@mui/icons-material/Close";
import { Card } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { ModalProps } from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import { ReactNode } from "react";

import { Typography } from "../../../components";
import { ModalDeprecated } from "../../../components/ModalDeprecated";

type AvailabilityModalProps = {
    open: boolean;
    onClose: () => void;
    footer?: ReactNode;
    children?: ReactNode;
} & ModalProps;

export const AvailabilityModal = ({ title, footer, open, onClose, children, ...props }: AvailabilityModalProps) => {
    return (
        <AvailabilityModalWrapper
            open={open}
            onClose={onClose}
            keepMounted={true}
            data-testid="availability-modal"
            {...props}
        >
            <CardWrapper>
                <Wrapper>
                    <Header data-has-title={!!title}>
                        {!!title && (
                            <HeaderTitle variant="title" size="large">
                                {title}
                            </HeaderTitle>
                        )}
                        <IconButton onClick={onClose} size="medium">
                            <CloseIcon />
                        </IconButton>
                    </Header>
                    <Content>{children}</Content>
                    {footer && <Footer>{footer}</Footer>}
                </Wrapper>
            </CardWrapper>
        </AvailabilityModalWrapper>
    );
};

const AvailabilityModalWrapper = styled(ModalDeprecated)(({ theme }) => ({
    "& .MuiPaper-root": {
        padding: theme.spacing(0),
        overflow: "hidden",
    },
}));

const CardWrapper = styled(Card)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    maxWidth: `calc(100vw - ${theme.spacing(2)})`,
    maxHeight: `calc(100vh - ${theme.spacing(2)})`,
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    boxSizing: "border-box",
    width: 600,
    [theme.breakpoints.down("md")]: {
        padding: theme.spacing(2, 1, 1, 1),
    },
}));

const Wrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(3),
    overflowY: "auto",
}));

const Header = styled("header")(({ theme }) => ({
    flexGrow: 0,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(2),
    '&[data-has-title="true"]': {
        justifyContent: "space-between",
        paddingBottom: theme.spacing(1),
        marginBottom: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
}));

const Content = styled("div")({
    flexGrow: 100,
});

const Footer = styled("footer")({
    flexGrow: 0,
    flexShrink: 0,
});

const HeaderTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));
